import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { FormikProps } from 'formik';
import { useState } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { FiltersFormTerritory } from 'system/geographic/pages/territory/list/types';
import PmiTextField from 'shell/components/shared/text-field';

interface FiltersTerritoryProps {
  filterTerritoryForm: FormikProps<FiltersFormTerritory>;
}

const FiltersTerritory = ({ filterTerritoryForm }: FiltersTerritoryProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-state-content"
        id="panel-state-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <form onSubmit={filterTerritoryForm.handleSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={3}>
              <PmiTextField
                aria-label="Codice territorio"
                label="Codice territorio"
                id="code"
                name="code"
                fullWidth
                onBlur={filterTerritoryForm.handleBlur}
                type="text"
                variant="outlined"
                inputProps={{
                  maxLength: '3',
                }}
                value={filterTerritoryForm.values.code}
                onChange={(event) =>
                  filterTerritoryForm.setFieldValue(
                    'code',
                    event.target.validity.valid
                      ? event.target.value
                      : filterTerritoryForm.values.code
                  )
                }
                error={filterTerritoryForm.touched.code && Boolean(filterTerritoryForm.errors.code)}
                helperText={filterTerritoryForm.errors.code}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Stato governante"
                label="Stato governante"
                id="state"
                name="state"
                fullWidth
                onBlur={filterTerritoryForm.handleBlur}
                type="text"
                inputProps={{
                  maxLength: '3',
                }}
                variant="outlined"
                value={filterTerritoryForm.values.state}
                onChange={(event) => {
                  filterTerritoryForm.setFieldValue('state', event.target.value);
                }}
                error={
                  filterTerritoryForm.touched.state && Boolean(filterTerritoryForm.errors.state)
                }
                helperText={filterTerritoryForm.errors.state}
              />
            </Grid>
            <Grid item xs={2}>
              <PmiButton
                variant="contained"
                color="secondary"
                type="submit"
                disabled={!filterTerritoryForm.isValid}
              >
                Cerca
              </PmiButton>
            </Grid>
          </Grid>
        </form>
      </AccordionDetails>
    </Accordion>
  );
};

FiltersTerritory.displayName = 'Filters Territory component';

export default FiltersTerritory;
